import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { OfflineBanner, Spinner } from '@/components';
import { IzteachSsoNotice } from '@/auth/IzteachSsoNotice';
import { useDeviceBottomInset } from '@/layout/useDeviceBottomInset';
import '@/styles/fonts.css';
import '@/styles/tokens.css';
import '@/styles/reset.css';
import '@/styles/shell.css';
import '@/styles/components.css';
import '@/styles/board.css';
import '@/styles/library.css';
import '@/styles/quiz-embed.css';
import '@/styles/question-bank.css';
import '@/styles/quiz.css';

export function App() {
  // the OS dock covers login and home too, so the inset is published above the router
  useDeviceBottomInset();
  const { t } = useTranslation('layout');

  return (
    <>
      <OfflineBanner />
      <IzteachSsoNotice />
      <Suspense fallback={<Spinner label={t('app.openingLesson')} size="large" />}>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </Suspense>
    </>
  );
}

export default App;
